import { Navigate, Route, Routes } from 'react-router-dom';

import { AppShell } from '@/components/layout/AppShell';
import { ProfilePage } from '@/features/account/pages/ProfilePage';
import { AnalyticsPage } from '@/features/analytics/pages/AnalyticsPage';
import { ProtectedRoute } from '@/features/auth/ProtectedRoute';
import { MindOSPage } from '@/features/mindos/pages/MindOSPage';
import { OAuthCallbackPage } from '@/features/auth/pages/OAuthCallbackPage';
import { SignInPage } from '@/features/auth/pages/SignInPage';
import { OverviewPage } from '@/features/sessions/pages/OverviewPage';
import { SessionDetailPage } from '@/features/sessions/pages/SessionDetailPage';
import { SessionsPage } from '@/features/sessions/pages/SessionsPage';

import { ModulePlaceholderPage } from './pages/ModulePlaceholderPage';
import { NotFoundPage } from './pages/NotFoundPage';

/**
 * Every authenticated screen sits under one `ProtectedRoute` + `AppShell`
 * pair, so a new module is one `<Route>` and one entry in `modules.ts`.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/auth/callback" element={<OAuthCallbackPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route index element={<OverviewPage />} />
          <Route path="sessions" element={<SessionsPage />} />
          <Route path="sessions/:sessionId" element={<SessionDetailPage />} />
          <Route path="mindos" element={<MindOSPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="profile" element={<ProfilePage />} />

          {/* Reserved routes for the modules listed in modules.ts. */}
          <Route path="compare" element={<ModulePlaceholderPage moduleId="compare" />} />
          <Route path="reports" element={<ModulePlaceholderPage moduleId="reports" />} />
          <Route path="protocols" element={<ModulePlaceholderPage moduleId="protocols" />} />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
